import styled from 'styled-components';

export const ColoredRound = styled.div`
  flex: 1;
  height: 36px;
  border-radius: 8px;
  background-color: ${({ color }) => color};
`;

export const TurnoverTooltipContainer = styled.div`
  display: flex;
  flex-direction: column;

  min-width: 200px;
  padding: 16px;

  border-radius: 5px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  box-shadow: 0px 4px 8px 0px ${({ shadowColor }) => shadowColor};
`;

export const TurnoverTooltipTitle = styled.div`
  margin-bottom: 16px;
  font: ${({ font }) => font};
  color: ${({ color }) => color};
`;

export const TurnoverTooltipRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;

  height: 20px;
  padding-left: ${({ isChild }) => (isChild ? '16px' : '0px')};

  border-bottom: 1px solid ${({ borderColor }) => borderColor};
`;

export const TurnoverTooltipLabel = styled.div`
  width: ${({ isChild }) => (isChild ? '112px' : '128px')};
  font: ${({ font }) => font};
  color: ${({ color }) => color};
`;

export const TurnoverTooltipValue = styled.div`
  width: 104px;
  font: ${({ font }) => font};
  color: ${({ color }) => color};
`;

export const StatusDropdownItem = styled.div`
  flex: 1;
  margin: 12px 0px;

  display: flex;
  align-items: center;
  column-gap: 8px;

  font: ${({ font }) => font};
`;

export const StatusDot = styled.div`
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`;

export const LegendButtonContainer = styled.div`
  flex-shrink: 0;
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid ${({ borderColor }) => borderColor};
  border-radius: 8px;
  cursor: pointer;
`;

export const LegendButtonIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const FilterButtonWrapper = styled.div`
  position: relative;
`;

export const FilterActiveIcon = styled.img`
  width: 14px;
  height: 14px;

  position: absolute;
  top: -5px;
  left: 233px;
`;
